import EfSectionLR from '@elem/ui/ef-section-l-r';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionLRA');
    return (
        <div className={styles.TheComp}>
            <EfSectionLR
                pc="https://websiteoss.ecoflow.com/upload/image/1725605169617/pc_CTC.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1725605217411/m_CTC.jpg"
                label={t('label')}
                title={t('title')}
                desc={t('desc')}
            />
        </div>
    );
}
